// extracted by mini-css-extract-plugin
export default {"page":"visitorPage_page__Stj1Y"};